<div [formGroup]="formGroup">
    <ckeditor
        #app
        *ngIf="isLayoutReady"
        [editor]="Editor"
        [config]="config"
        [formControlName]="formControlName"></ckeditor>
</div>

<!-- <div class="main-container">
    <div
        class="editor-container editor-container_classic-editor editor-container_include-style"
        #editorContainerElement>
        <div class="editor-container__editor">
            <div #editorElement>
                <ckeditor
                    [editor]="Editor"
                    [config]="config"
                    *ngIf="isLayoutReady"
                    [formControlName]="formControlName" />
            </div>
        </div>
    </div>
</div> -->
